import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar1 from "./components/Navbar1";
import Preloader from "./components/Preloader";

import Home from "./pages/Home";
import Projects from "./pages/Projects";
import News from "./pages/News";
import Contact from "./pages/Contact";
import About from "./pages/About";

function App() {
  const [preloaderDone, setPreloaderDone] = useState(false);

  return (
    <Router>
      {/* Website content is always mounted */}
      <>
        <Navbar1 />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </>

      {/* Preloader on top */}
      {!preloaderDone && (
        <Preloader
          duration={2000} // how long to show video before sliding
          onFinish={() => setPreloaderDone(true)}
        />
      )}
    </Router>
  );
}

export default App;
